const DIACRITICS = /[̀-ͯ]/g;
const NON_ALPHANUMERIC = /[^a-z0-9]+/;

export const toNameWords = clientName =>
  (clientName || '')
    .normalize('NFD')
    .replace(DIACRITICS, '')
    .toLowerCase()
    .split(NON_ALPHANUMERIC)
    .filter(Boolean);

const capitalize = word => word.charAt(0).toUpperCase() + word.slice(1);

export const toConstantCase = words => words.join('_').toUpperCase();

export const toCamelCase = ([first = '', ...rest]) =>
  first + rest.map(capitalize).join('');

export const toKebabCase = words => words.join('-');
